<script>

/**
 * Nav-bar Component
 */
export default {
  components: {},
  props: {
    value: Object,
  },
  data() {
    return {
      localValue: this.value.fieldsForLocalState ?? {}
    };
  },
  created() {
  },
  watch: {
    value: function (newVals) {
      this.localValue = newVals.fieldsForLocalState ? newVals.fieldsForLocalState : {}
    },
    localValue: {
      handler(newVals) {
        const returnedValues = {
          fieldsForAdvancedSearch: {},
          fieldsForLocalState: newVals
        }

        this.$emit('input', returnedValues)
      },
      deep: true
    }
  },
  methods: {}
};
</script>

<template>
  <div>
    <b-row>
      <b-col></b-col>
    </b-row>
  </div>
</template>
